import React from 'react';
import CommonHeader from './CommonHeader';
import CommonFooter from './CommonFooter';
import './CommonLayout.css';

const CommonLayout = ({ children, user, onLogout, showTabs, activeTab, onTabChange }) => {
  return (
    <div className="common-layout">
      <CommonHeader 
        user={user} 
        onLogout={onLogout}
        showTabs={showTabs}
        activeTab={activeTab}
        onTabChange={onTabChange}
      />
      <main className="common-body">
        {children}
      </main>
      <CommonFooter />
    </div>
  );
};

export default CommonLayout;
